/** @format */

import React from "react"
import FirstStep from "./components/FirstStep"
import StepSetter from "./components/StepSetter"
import * as Scroll from "react-scroll"
// import { useSelector } from "react-redux"

// const contractStatus = useSelector(
//   (state) => state.contractStatus.contractStatus
// )

export default () => {
  // const [currentStep, setCurrentStep] = React.useState("2")
  const [test, setTest] = React.useState(true)
  const scroll = Scroll.animateScroll

  React.useEffect(() => {
    scroll.scrollToTop()
  }, [])

  return (
    <>
      {/* currentStep === "1" */}
      {test ? (
        // stepOBJ={{ currentStep, setCurrentStep }}
        // stepOBJ={{ test, setTest }}
        <FirstStep stepOBJ={{ test, setTest }} />
      ) : (
        // stepOBJ={{ currentStep, setCurrentStep }}
        <StepSetter />
      )}
    </>
  )
}
